
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as transcriptViewerActions from '../../transcriptViewerActions'
import MessageDisplayArea from '../../../../_dependencies/js_chat_clients/module/dev/room/message-display-area/MessageDisplayArea.tsx'
import { createMessage } from '../../../../_dependencies/js_chat_clients/module/dev/room/message-display-area/messages/messageHelpers.ts'
import { textDisplayTemplate } from '../../../../_dependencies/js_chat_clients/operator/dev/src/libs/store/middleware/rooms/messages.js'
import { transformFileMessages, tryDownloadFile } from './transformFileMessages.jsx'
import '../../../../_dependencies/js_chat_clients/module/dev/room/message-display-area/MessageDisplayArea_operator.scss'
import './MessageDisplayAreaWrapper.scss'

const MessageDisplayAreaWrapper = ({
  transcript, texts, linksFromBlobByURL, urlsAlreadyDownloading, messageDisplayAreaRef, downloadFile,
  fileForPreviewStartDownload,
}) => {
  if (!transcript || !transcript.messages) return null

  const transformedFileMessages = transformFileMessages({
    messages: transcript.messages,
    transcriptId: transcript.transcriptId,
    texts,
    linksFromBlobByURL,
    urlsAlreadyDownloading,
    fileForPreviewStartDownload,
  })

  const messages = transformedFileMessages.map((message, ii) => createMessage({
    ...message,
    id: ii,
    nickname: message.authorName,
    date: message.created,
    type: message.authorName === 'System' ? 'system' : 'visitor',
    subtype: message.messageType.split('-')[1],
    clientTimestamp: Date.now() + ii,
    isFake: false,
    translatedTextHtml: message.translatedText,
    visitorServerUrl: 'https://messenger.providesupport.com',
    textDisplayTemplate,
    // authorId
    // modCount
  }))

  return (
    <MessageDisplayArea
      messages={messages}
      typingsMessages={[]}
      fileMessageText={{}}
      options={{
        showTime: true,
        showSpinner: false,
        showTypings: false,
        // fileTransfer: {
        //   chash: session.companyIdHash,
        //   fileTransferSessionId: room.fileTransferSessionId,
        //   nickName: session.operatorLogin,
        //   connectionId: network.connectionId,
        // },
        isChatShouldShowUp: true,
        initialScrollTop: 0,
        customScrollTop: 0,
        // messageViewType: 'a',
        roomId: transcript.transcriptId,
        // draftUnreadMessages: 0,
        companyHeaderParams: {
          isUseHeader: false,
          headerAlign: 'right',
          homeUrl: '',
          companyHeaderUrl: '',
        },
        // operatorsData: {},
      }}
      texts={{}}
      saveDraftUnreadMessages={() => {}}
      onScroll={() => {}}
      onRemoveMessage={() => {}}
      onUnmount={() => {}}
      onClick={tryDownloadFile(downloadFile)}
      ref={messageDisplayAreaRef}
    />
  )
}

MessageDisplayAreaWrapper.propTypes = {
  transcript: PropTypes.object.isRequired,
  texts: PropTypes.object.isRequired,
  linksFromBlobByURL: PropTypes.object.isRequired,
  urlsAlreadyDownloading: PropTypes.object.isRequired,
  messageDisplayAreaRef: PropTypes.any,
  downloadFile: PropTypes.func,
  fileForPreviewStartDownload: PropTypes.func,
};

export default connect(
  state => ({
    texts: state.app.texts,
    linksFromBlobByURL: state.transcriptViewer.preview.media.linksFromBlobByURL,
    urlsAlreadyDownloading: state.transcriptViewer.preview.media.urlsAlreadyDownloading,
  }), dispatch => bindActionCreators({
    downloadFile: transcriptViewerActions.downloadFile,
    fileForPreviewStartDownload: transcriptViewerActions.fileForPreviewStartDownload,
  }, dispatch),
)(MessageDisplayAreaWrapper);
